module.exports = __webpack_public_path__ + "img/newsImg11-20.3882d1e2.png";